const collapsableMenu = {
	el: {
		body: $('body'),
		header: {
			domEl: $('.header'),
			toggleButton: $('.header__menu-toggle-button')
		},
		sidenav: {
			domEl: $('.sidenav'),
			toggleButton: $('.sidenav__toggle-button')
		}
	},
	toggleMenu(menu) {
		this.el[menu].toggleButton.on('click', () => {
			this.el[menu].domEl.toggleClass('collapsed')
			
			menu === 'header' ? this.el.body.toggleClass('no-scroll') : ''
		});

	},
	init() {
		this.toggleMenu('header');
		this.toggleMenu('sidenav');
	}
}

collapsableMenu.init();